import qs from 'qs';

export const parseParametersToSendBackend = (params:object):string => {
    let parsedParams = JSON.parse(JSON.stringify(params));

    Object.keys(parsedParams).forEach((key) => {
        if(Array.isArray(parsedParams[key])){
            parsedParams[key] = parsedParams[key].join(',')
        }
    })

    if(parsedParams.hasOwnProperty('sort_by')){
        //formateo las columnas que apuntan a una clave dentro de un diccionario
        //backend las prefiere con guion bajo en lugar de punto
        
        if(parsedParams['sort_by'].includes('.')){
            parsedParams['sort_by'] = parsedParams['sort_by'].replace(/\./g, '_');
        }        
    }
    
    return qs.stringify(parsedParams, { encode: false });
}